import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { SignalsSimpleStoreService } from '@core/services';
import { PasswordForgetApiService } from './password-forget-api.service';

export interface PasswordForgetServiceState {
  loading: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PasswordForgetService extends SignalsSimpleStoreService<PasswordForgetServiceState> {
  constructor(private passwordForgetApiService: PasswordForgetApiService) {
    super();
  }

  /**
   * Call forget password API .
   * @param {string} email - User email.
   * @param {string} redirectUrl - Password reset page redirect URL.
   * @returns {Observable<void>} Observable.
   */
  forgetPassword(email: string, redirectUrl: string): Observable<void> {
    this.set('loading', true);
    return this.passwordForgetApiService.forgetPassword(email, redirectUrl).pipe(
      tap(() => {
        this.set('loading', false);
      }),
    );
  }
}
